import { IncomeApi } from "../api";

export class Income {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
  }
  static async createIncome(formData) {
    const { data } = await IncomeApi.createIncome(formData);
    return new Income(data.result);
  }
  static async updateIncome(formData) {
    const { data } = await IncomeApi.updateIncome(formData);
    return new Income(data.result);
  }
  static async removeIncome(id) {
    const { data } = await IncomeApi.removeIncome(id);
    return data.result
  }
  static async getIncome(id) {
    const { data } = await IncomeApi.getIncome(id);
    return new Income(data.result);
  }
  static async getIncomeBetweenDateByMarket(formData) {
    const { data } = await IncomeApi.getIncomeBetweenDateByMarket(formData);
    return data.result.map(item => new Income(item));
  }
  static async getIncomeExpenseSummaryByMarket(formData) {
    const { data } = await IncomeApi.getIncomeExpenseSummaryByMarket(formData);
    return data.result;
  }
}